import { render, staticRenderFns } from "./ContributorPortrait.vue?vue&type=template&id=5492151e&scoped=true"
import script from "./ContributorPortrait.vue?vue&type=script&lang=js"
export * from "./ContributorPortrait.vue?vue&type=script&lang=js"
import style0 from "./ContributorPortrait.vue?vue&type=style&index=0&id=5492151e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5492151e",
  null
  
)

export default component.exports